<div class="widget-container" #pivotGridDiv>
  <main>

    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
  <div>
    <icon-chart 
        [headerConfig]="this.item.config.widget_header_config" 
        [iconList]="iconList" 
        [data]="rowData" 
        [pageKey]="pageKey" 
        [heading]="item.config['rcharteport_heading']"
        [chartName]="'pivotGrid'" 
        [config]="aggrid" 
        [expand]="fs" 
        [fullscreen]="isFullscreen"
        [item]="item"
        (fullscreenChange)="fullscreenChanges($event)"
        (expendCol)="expendCol($event)"
      ></icon-chart>
  </div>
  
  <!-- <div style="display:flex;flex-direction:row">
    <span style="flex:1;"><h2 style="font-weight: 500;">{{item.config['report_heading'] || ' No Header'}}</h2></span>
    <span>
      <mat-icon [svgIcon]="expandCollapseIcon" (click)="expandCollapse()" [matTooltip]="expandOrCollapse"  class="matExpandCollapseBtn"></mat-icon>
      <mat-icon matTooltip="Setting" *ngIf="item.config['list_of_api'].api_key==100142"  class="matIcons" svgIcon="setting" [matMenuTriggerFor]="setting"></mat-icon>
      <mat-icon matTooltip="Export List"  class="matIcons" svgIcon="dotmenu_circle" [matMenuTriggerFor]="menu"></mat-icon>
    </span>
  </div> -->

  <mat-menu #menu="matMenu">
    <button mat-menu-item  (click)="exportXls()"><mat-icon svgIcon="xls" ></mat-icon>Export XLS</button>
  </mat-menu>

  <mat-menu #setting="matMenu">
    <div mat-subheader style="background-color: #e8e8e8;margin: 3px;border-radius: 8px 8px 0px 0px;padding: 10px;margin: 2px;" > Table view</div>
    <div style="margin: 10px; cursor: pointer;"  (click)="showByValue('source')"> By SP  </div>
    <div style="margin: 10px; cursor: pointer;" (click)="showByValue('NDC')" > By NDCs </div>
  </mat-menu>

  <div style="height: 200px; width: auto; " *ngIf="!loader && rowData.length==0">
    <span class="bg-text"> {{ error_name ? error_name : 'There is no data for this time period' }} </span>
  </div>
  
  <div *ngIf="loader" style="height: 200px; width: auto;">
    <loading></loading>
  </div>

  <div class="example-wrapper" #aggrid>
    <ag-grid-angular
      #aggrid
      [style.display]="(rowData?.length==0 || error_name) ? 'none' : 'block'"
      style="width:100%;padding: 10px;"
      [style.height]="(this.item.config?.['chartHeight'] && !isFullscreen) ? (this.item.config?.['chartHeight']+'px'|| '500px') :'100%'"
      class="ag-theme-alpine-dark test overFlowAdd"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [processPivotResultColGroupDef]="processSecondaryColGroupDef"
      [pivotMode]="true"
      [animateRows]="true"
      [rowHeight]="rowHeight"
      [suppressRowTransform]="true" 
      [rowData]="rowData"
      [suppressDragLeaveHidesColumns]="true"
      [sideBar]="sideBar"
      [pivotHeaderHeight]="0"
      (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
      <!-- [overlayNoRowsTemplate]="overlayNoRowsTemplate" -->
  </div>
    </article>
  </main>
</div>
